export default __webpack_public_path__ + "static/media/image3.d2c7087a.jpg";